module.exports = __webpack_public_path__ + "img/15.be519c67.jpg";